import { createSelector } from 'reselect'
import { Finance } from 'finance'
import { selectNewPrimaryResidenceMortgageRate } from 'src/store/selectors/mortgageRate'
import {
  selectLeverageableEquityForLTV_80,
  asDownPaymentPercent
} from './equity'
import { rentBuy, rentalProperty } from 'src/constants/equity'

export const selectNewPrimaryResidenceDownPayment = selectLeverageableEquityForLTV_80

export const selectNewPrimaryResidenceBudget = createSelector(
  selectNewPrimaryResidenceDownPayment,
  asDownPaymentPercent(rentBuy.downPaymentPercent)
)

const selectBudgetAfterDownpayment = createSelector(
  selectNewPrimaryResidenceBudget,
  selectNewPrimaryResidenceDownPayment,
  (budget, downpayment) => budget - downpayment
)

export const selectNewPrimaryResidenceMonthlyPayment = createSelector(
  selectBudgetAfterDownpayment,
  selectNewPrimaryResidenceMortgageRate,
  (budget, rate) =>
    Finance.calculatePayment(budget, rentalProperty.loanTerm * 12, rate)
)
